import React, { useMemo } from 'react';
import { bool, func } from 'prop-types';
import { I18n } from '@fiverr-private/i18n-react';
import { Button } from '@fiverr-private/fit';
import pathfinder from '@fiverr-private/pathfinder';
import { triggerSignUp } from '@fiverr-private/identification_triggers';
import monitor from '../../../../service/bigquery';
import { APP_NAME } from '../constants';
import { useChooseVariationContext } from '../Context';
import { VARIATION_TYPE } from '../ChooseVariation/constants';
import classes from './index.module.scss';

const getEditorLink = (projectId, variationId, brandName, slogan, briefId) =>
    pathfinder(
        'logo_maker_buyer_editor_page',
        { project_id: projectId, variation_id: variationId },
        {
            query: {
                brand_name: brandName,
                source: APP_NAME,
                ref_ctx_id: monitor.context.refCtxId,
                ...(slogan && { slogan }),
                ...(briefId && { brief_id: briefId }),
            },
        }
    );

const openSignUpModal = async () => {
    try {
        await triggerSignUp({
            modalOptions: {
                triggerType: 'blocked_action',
            },
        });
    } catch {
        window.location.assign(pathfinder('join'));
    }
};

const Navigation = ({ isDisabled, isLoading, onPurchase }) => {
    const { userId, projectId, selectedVariation, briefId, brandName, slogan, isProjectOwner, hasFreeVariations } =
        useChooseVariationContext();

    const editorLink = useMemo(
        () => getEditorLink(projectId, selectedVariation.id, brandName, slogan, briefId),
        [projectId, selectedVariation.id, brandName, slogan, briefId]
    );

    return (
        <>
            {!isProjectOwner && (
                <Button
                    {...(userId ? { href: editorLink } : { onClick: openSignUpModal })}
                    className={classes.actionBtn}
                    fill={Button.FILLS.GHOST}
                    color={Button.COLORS.BLUE}
                    size={Button.SIZES.SMALL}
                    loading={isLoading}
                    disabled={isDisabled || isLoading}
                >
                    <I18n k="logo_maker_perseus.choose_variation.navigation.customize_logo" />
                </Button>
            )}

            {selectedVariation.type !== VARIATION_TYPE.ORDERED && (
                <Button
                    onClick={onPurchase}
                    className={classes.actionBtn}
                    color={Button.COLORS.BLUE}
                    size={Button.SIZES.SMALL}
                    loading={isLoading}
                    disabled={isDisabled || isLoading}
                >
                    <I18n
                        k={`logo_maker_perseus.choose_variation.navigation.${
                            hasFreeVariations ? 'download' : 'buy_logo'
                        }`}
                    />
                </Button>
            )}
        </>
    );
};

Navigation.propTypes = {
    isDisabled: bool,
    isLoading: bool,
    onPurchase: func,
};

export default Navigation;
